import "./App.css";
import Contact from "./components/landing/Contact";
import FAQ from "./components/landing/FAQ";
import Features from "./components/landing/Features";
import Footer from "./components/landing/Footer";
import Header from "./components/landing/Header";
import Hero from "./components/landing/Hero";
import Pricing from "./components/landing/Pricing";
import Testimonials from "./components/landing/Testimonials";
import { ThemeProvider } from "./context/ThemeContext";

function App() {
  return (
    <ThemeProvider>
      <div className="min-h-screen bg-[var(--bg-page)] transition-theme">
        <Header />
        <main id="main-content" aria-label="SEFIL 360 website sections">
          <Hero />
          <Features />
          <Pricing />
          <Testimonials />
          <FAQ />
          <Contact />
        </main>
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
